import { selectIssueById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { issueDetailsViewLayoutHandle } from "src/views/IssueDetailsView/constants"
import { IssueDetailsView } from "src/views/IssueDetailsView/IssueDetailsView"
import { NotFound } from "src/views/IssueDetailsView/NotFound"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issues/$issueId")({
	loader: ({ params }) => {
		const issue = selectIssueById(params.issueId)(appStore.getState())
		if (!issue) throw notFound()
	},
	component: IssueDetailsView,
	remountDeps: ({ params }) => [params.organizationId, params.projectId, params.issueId],
	staticData: issueDetailsViewLayoutHandle,
	notFoundComponent: NotFound,
})
